// extracted by mini-css-extract-plugin
module.exports = {"container":"tempSuccess_container__2e9RJ","successImage":"tempSuccess_successImage__3KXOx","button":"tempSuccess_button__3ieWl"};